<template>
  <div
    id="site-wrapper"
    class="page background--grey"
  >
    <DtvaHeader :current-route-name="$router.currentRoute.name" />
    <main>
      <router-view />
    </main>
    <global-success />
    <global-warning />
    <global-error />
    <DtvaFooter />
  </div>
</template>

<script>

  import DtvaHeader from "@/components/dtva-header/DtvaHeader";
  import DtvaFooter from "@/components/dtva-footer/DtvaFooter";

  export default {
    components: {DtvaHeader, DtvaFooter},
    data: function() {
      return {
      };
    },
    methods: {
    },
  };
</script>

<style lang="scss" src="./components/dtva-header/dtva-header.scss">
</style>

<style lang="scss" src="./components/dtva-footer/dtva-footer.scss">
</style>

<style lang="scss" src="@groot/falbala/src/core/scss/drei.scss">
</style>
